import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LineDataContainer from './LinesDataContainer';
import { fetchLineDataInformation } from 'redux/lineDataInformation/LineDataInformationActions';

const mapStateToProps = ({ lineData }) => ({
  fetchingLineDataInformation: lineData.fetchingLineDataInformation,
  linesCount: lineData.linesCount
});

const mapDispatchToProps = dispatch => ({
  lineDataActions: bindActionCreators({ fetchLineDataInformation }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LineDataContainer);



// WEBPACK FOOTER //
// ./src/components/dashboard/comp/linesData/LinesDataConnector.js